import { render, staticRenderFns } from "./ExitWithoutSave.vue?vue&type=template&id=6a55ce4c&scoped=true&"
import script from "./ExitWithoutSave.vue?vue&type=script&lang=js&"
export * from "./ExitWithoutSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a55ce4c",
  null
  
)

export default component.exports